
let faqContainer = document.getElementById('faq-content')
let questions = faqContainer.querySelectorAll('div')

let categoryTitle = document.getElementById('faq-category-title')
let subCategoryTitle = document.getElementById('faq-subcategory-title')
let faqLink = document.getElementById('faq-link')




/*
faqLink.addEventListener('click', (e)=> {
  if(e.target.classList.contains('faq-link')) {
    faqContainer.classList.add('active')

    if(categoryTitle)
      categoryTitle.innerHTML = e.target.dataset.category
    if(subCategoryTitle)
      subCategoryTitle.innerHTML = e.target.dataset.subcategory

    window.scrollTo(0, faqContainer.offsetTop - 100);

    let faqItem = [];
    let faqCategoryList = faqContainer.querySelectorAll('.category')
    
    faqCategoryList.forEach(item => {
      let itemTag = item.dataset.tags;
      if(itemTag.includes(`${e.target.dataset.category}`) &&  itemTag.includes(`${e.target.dataset.subcategory}`) ) 
        faqItem.push(item)
    })
    
    console.log("CATEGORY " + e.target.dataset.category )
    console.log("SUBCATEGORY " + e.target.dataset.subcategory)
    console.log(faqItem)

    questions.forEach(item => {
      item.classList.remove('active')
      item.classList.add('hide')
    })

    faqItem.forEach(item => {
      item.classList.add('active')
      item.classList.remove('hide')
    })
  }
})
*/


